export default {
    assetsroot: "https://res.to2025.com/assets/7/",
    imgPrefix: "https://res.to2025.com/assets/exih/img/",
    icon_prefix: "https://dat.to2025.com/exihelper/ua/icon/",

    // up_prefix: "http://tstdat.to2025.com/exihelper/ua/",
    // comfile_prefix: "http://tstdat.to2025.com/exihelper/cf/",
    // pages_prefix: "http://tstdat.to2025.com/exihelper/pages/",
    // // apiroot: "http://localhost:56503/",
    // apiroot: "http://www.gyh1.com:703/api-toc/",

    up_prefix: "https://dat.to2025.com/exihelper/ua/",
    comfile_prefix: "https://dat.to2025.com/exihelper/cf/",
    apiroot: "https://www.zhanxiaobang.cn/api/",
    pages_prefix: "https://dat.to2025.com/exihelper/pages/",

    com_logo_suffix: "?x-oss-process=image/resize,m_pad,h_256,w_256,color_ffffff",
}



// WEBPACK FOOTER //
// ./src/utils/appsettings.js